import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup,  Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Subscription } from 'rxjs';
import { Campaign } from 'src/app/models/Campaign';
import { LeadList } from 'src/app/models/LeadList';
import { Tag } from 'src/app/models/Tag';
import { urlValidatorService } from 'src/app/shared/validators/url.validator.service';
import { AuthService } from '../../../shared/services/auth.service';
import { User } from '../../../models/User';
import { BlacklistValidatorService } from '../../../shared/validators/blacklist.validator.service';
import { IntervalType } from '../../../models/IntervalType';
import { Sequence } from '../../../models/Sequence';
import { ConfirmationService } from '../../../shared/components/confirmation-modal/confirmation.service';
import { ToastService } from '../../../shared/components/toast/toast.service';
import { SequencesService } from '../../../shared/services/sequences.service';
import { Call4UService } from 'src/app/shared/services/call4u.service';
import { Call4uAudioService } from 'src/app/shared/services/call4u-audio.service';
import { Call4uAudio } from 'src/app/models/Call4uAudio';
import { HOTMART, APPMAX, PERFECTPAY} from 'src/app/shared/services/integrations.service';
import { platformPatternValidator } from 'src/app/shared/validators/platformpattern.validator.service';
import { detectPlatformByPattern } from 'src/app/shared/validators/platformpattern.validator.service';
import { IntegrationActivationStatus } from 'src/app/models/IntegrationActivated';
import { Tag as AC_TAG } from 'src/app/models/ActiveCampaign';
import { ActiveCampaignService } from 'src/app/shared/services/active-campaign.service';
import { environment } from 'src/environments/environment';
import { LeadVariable, MetaTemplate, MetaWhatsappService } from 'src/app/shared/services/meta-whatsapp.service';
import { WhatsappAccount, WhatsappAccountsService } from 'src/app/shared/services/whatsapp-accounts.service';
import { HOUR_INTERVAL, WhatsappSequenceModalComponent } from './whatsapp-sequence-modal/whatsapp-sequence-modal.component';
import {
  fillTemplateText, findTemplate, isLegacyMapping, mappingSource, MY_LINK_LABEL, MY_LINK_TOKEN, normalizeTemplateMapping, templateBodyText,
  templateSlots,
} from 'src/app/shared/utils/whatsapp-template';

/** Variáveis do template de um item de WhatsApp, para o card. */
export interface ItemTemplateVariables {
  summary: string;
  /** Variáveis "de nome" do passo antigo que vão com o primeiro nome do lead. */
  defaulted: string[];
  /** Variáveis sem dado nenhum: o envio cancela até o passo ser editado. */
  missing: string[];
}
import { isAccountBroken, isAccountUsable } from 'src/app/shared/utils/whatsapp-account-status';

import {
  RCS_READ_CONDITION_DEFAULT_HOURS,
  RCS_READ_CONDITION_DISABLED,
  RCS_STAGE_LABELS,
  RcsAgent,
  RcsContent,
  RcsReadCondition,
  RcsReadConditionSettings,
} from 'src/app/models/Rcs';
import { RcsEditorState, RcsVariable } from 'src/app/shared/rcs/rcs-editor/rcs-editor.component';
import { RcsAgentService } from 'src/app/shared/services/rcs-agent.service';
import { RcsSettingsService } from 'src/app/shared/services/rcs-settings.service';
import { emptyContent, normalizeContent, readConditionProblems } from 'src/app/shared/utils/rcs-rules';

/** Data de corte das sequências Voxuy legadas (Decisão 4 do protótipo da M4). */
export const VOXUY_CUTOFF = '30/11/2026';

/**
 * Tipo da etapa RCS no `sequence_type`, ao lado de `sms` e `whatsapp`. O payload
 * espelha o da etapa de WhatsApp e acrescenta `rcs_agent_id` e `rcs_content`
 * (contrato do RCS, "Etapa de automação").
 */
export const RCS_SEQUENCE_TYPE = 'rcs';

/** O backend grava e devolve a etapa RCS como `controls_rcs` (valor do ENUM); a tela trabalha com `rcs`. */
export function normalizeSequenceType<T extends { sequence_type?: string }>(sequence: T): T {
  return sequence?.sequence_type === 'controls_rcs' ? { ...sequence, sequence_type: RCS_SEQUENCE_TYPE } : sequence;
}

@Component({
  selector: 'app-sequences',
  templateUrl: './sequences.component.html',
  styleUrls: ['./sequences.component.scss']
})
export class SequencesComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('modalSequence', {static: true}) modalSequence: ElementRef<any>;
  @Input() form: UntypedFormGroup;
  @Input() campaign: Campaign;
  @Input() leadList: LeadList;
  /**
   * A lista chega do pai (edição da automação) crua do backend, com a etapa RCS como
   * `controls_rcs`; sem normalizar aqui ela aparecia como "Mensagem de SMS" ao abrir a
   * tela, e só virava RCS depois de salvar alguma etapa (que recarrega pela linha de baixo).
   */
  @Input()
  set sequences(value: Sequence[]) {
    this._sequences = value ? value.map(normalizeSequenceType) : value;
  }
  get sequences(): Sequence[] {
    return this._sequences;
  }
  private _sequences: Sequence[];

  /** Recarga da lista de sequências depois de salvar ou excluir. */
  loadingSequences = false;

  /** Gravação em curso — ver `persistSequence`. */
  saving = false;


  @ViewChild('modalTag', {static: true}) modalTag: ElementRef<any>;

  modalTitle;

  tags: Tag[] = [];

  CALL4U_DOCS: string;

  startPosition = 0;
  endPosition = 0;
  messageMaxLength = 140;

  user: User;

  msgType: any = 1;
  sendLeadNumber = false;
  usedCall4U = false;

  call4uAudios: Call4uAudio[] = [];

  intervalTypes: IntervalType[] = [];
  sequenceForm: UntypedFormGroup;

  AC_Activated = false;
  AC_selected_tags: AC_TAG[] = [];
  AC_preselected_all: AC_TAG[] = [];
  AC_preselected_selected: AC_TAG[] = [];
  AC_tags: AC_TAG[] = [];

  tagForm: UntypedFormGroup;

  tagMode = 1;
  tagInEdit?: AC_TAG;

  refreshAC = false;

  list_integration: string[] = [HOTMART, APPMAX, PERFECTPAY]; // Futuramente transformaremos em uma lista
  have_list_integration: boolean; // Este retiraremos depois que for implantado em outras plataformas
  checkout_cross_platform: string | boolean;

  subscriptions: Subscription[] = [];

  readonly voxuyCutoff = VOXUY_CUTOFF;

  /** Etapa RCS: agente e card ficam fora do form reativo, com o editor compartilhado. */
  rcsAgentId: string | null = null;
  rcsContent: RcsContent = emptyContent();
  rcsState: RcsEditorState | null = null;
  rcsAgents: RcsAgent[] = [];
  readonly rcsStageLabels = RCS_STAGE_LABELS;

  /**
   * Condição "se não ler em X h, enviar SMS" (F7.5), atrás da flag global
   * `RCS_SEQUENCE_READ_CONDITION`: desligada (padrão), o bloco não aparece e o payload não
   * leva o campo — o backend recusaria a condição com 422 e mantém a que já estiver gravada.
   */
  readConditionSettings: RcsReadConditionSettings = RCS_READ_CONDITION_DISABLED;
  readConditionOn = false;
  readConditionHours: number = RCS_READ_CONDITION_DEFAULT_HOURS;
  readConditionText = '';

  get readConditionProblems(): string[] {
    if (!this.readConditionSettings.enabled || !this.readConditionOn) {
      return [];
    }

    return readConditionProblems({ hours: this.readConditionHours, sms_text: this.readConditionText }, this.readConditionSettings);
  }

  setReadCondition(condition?: RcsReadCondition | null): void {
    this.readConditionOn = !!condition;
    this.readConditionHours = condition?.hours ?? RCS_READ_CONDITION_DEFAULT_HOURS;
    this.readConditionText = condition?.sms_text ?? '';
  }

  /**
   * RCS na conta. Visualizando outra conta, a API confere o RCS do administrador (403 sem
   * a flag dele, como a IA): a opção some em vez de abrir um editor que não carrega agentes.
   */
  get rcsEnabled(): boolean {
    if (!this.user?.rcs_enabled) {
      return false;
    }
    return !(this.auth.isSimulating && !this.auth.getLoggedInUser()?.rcs_enabled);
  }

  /**
   * O modal da etapa RCS abre largo: o editor tem a prévia do celular ao lado do formulário,
   * e no `lg` os campos dos botões ficam estreitos demais. Os outros tipos seguem no `lg`.
   */
  private modalSizeFor(sequenceType: string): string {
    return sequenceType === RCS_SEQUENCE_TYPE ? 'xl' : 'lg';
  }

  /**
   * As mesmas variáveis da etapa de SMS desta lista, sem as chaves e sem espaço.
   * Campo, e não getter: um array novo a cada detecção refaria os chips do editor.
   */
  rcsVariables: RcsVariable[] = [];

  /** Nome do agente (remetente) da etapa RCS, para o chip do passo; some se o agente não veio na lista. */
  rcsAgentName(sequence: Sequence): string | null {
    if (sequence.sequence_type !== RCS_SEQUENCE_TYPE || !sequence.rcs_agent_id) {
      return null;
    }
    return this.rcsAgents.find(item => item.id === sequence.rcs_agent_id)?.name || null;
  }

  /** Quantos botões o card da etapa RCS tem (0 = sem chip). */
  rcsButtonCount(sequence: Sequence): number {
    return (sequence.rcs_content?.buttons || []).filter(button => !!button?.label).length;
  }

  /** Agente da etapa RCS quando ele não está ativo: a etapa fica pausada e nada é cobrado. */
  rcsPausedAgent(sequence: Sequence): RcsAgent | null {
    if (sequence.sequence_type !== RCS_SEQUENCE_TYPE) {
      return null;
    }
    const agent = this.rcsAgents.find(item => item.id === sequence.rcs_agent_id);
    return agent && agent.stage !== 'active' ? agent : null;
  }

  /**
   * Números de WhatsApp do cliente (M4). Sem nenhum pronto, o botão WhatsApp fica desabilitado
   * com o caminho para Integrações; o status também alimenta o aviso de token expirado no item.
   */
  whatsappAccounts: WhatsappAccount[] = [];
  loadingAccounts = false;
  /** A lista de números não veio: o botão não fica cinza por "falta de número" — oferece tentar de novo. */
  accountsError = false;

  /** Templates por número, para mostrar o corpo do template no item da linha do tempo. */
  private templatesByAccount: { [accountId: string]: MetaTemplate[] } = {};
  private leadVariables: LeadVariable[] = [];

  /**
   * Corpo do template de cada item, já com o dado de cada variável. Calculado quando os
   * templates, as variáveis ou os itens chegam — não a cada ciclo de detecção da tela.
   */
  itemBodies: { [sequenceId: string]: string } = {};
  itemVariables: { [sequenceId: string]: ItemTemplateVariables } = {};

  /**
   * Itens que a automação mostra mas não edita (M4):
   * - Voxuy, legado até a data de corte (Decisão 4);
   * - a "Conversa com IA" (controls_ai) que já existia: continua rodando e é configurada onde
   *   nasceu, IA → Meus Agentes → Listas & eventos, junto com os prompts por evento;
   * - o "Meu WhatsApp" antigo: passo `whatsapp` de texto livre, sem template, do canal por QR
   *   que saiu na 86ajutm9y. O modal novo exige número e template e converteria o passo
   *   apagando o texto — então ele fica visível, com o texto, e é recriado como passo novo.
   */
  isReadOnly(sequence: Sequence): boolean {
    return sequence.sequence_type === 'voxuy'
      || sequence.sequence_type === 'controls_ai'
      || this.isLegacyWhatsapp(sequence);
  }

  isLegacyWhatsapp(sequence: Sequence): boolean {
    return sequence.sequence_type === 'whatsapp' && !sequence.template_name;
  }

  /** Qual corpo o item mostra na linha do tempo. */
  bodyKind(sequence: Sequence): string {
    if (this.isLegacyWhatsapp(sequence)) {
      return 'wa-legacy';
    }
    return ['whatsapp', 'voxuy', 'controls_ai', RCS_SEQUENCE_TYPE].includes(sequence.sequence_type) ? sequence.sequence_type : 'default';
  }

  get sequenceType(): string {
    return this.sequenceForm.get('sequence_type').value ?? 'sms';
  }

  /**
   * WhatsApp oficial é por conta (flag); sem ela o botão nem aparece, como o dropdown antigo. A
   * conta só com IA não cria o passo — o envio exige a flag do canal (decisão na task).
   */
  get whatsappAvailable(): boolean {
    return !!this.user?.whatsapp_enabled;
  }

  get hasWhatsappNumber(): boolean {
    return this.whatsappAccounts.some(isAccountUsable);
  }

  /** O campo "Meu link" do SMS só aparece quando a mensagem tem a tag (mesma regra do WhatsApp). */
  get smsUsesLink(): boolean {
    return (this.sequenceForm.get('text').value || '').includes('{meu_link}');
  }

  constructor(
    private sequencesService: SequencesService,
    private modalService: NgbModal,
    private auth: AuthService,
    private toastService: ToastService,
    private formBuilder: UntypedFormBuilder,
    private blacklistValidator: BlacklistValidatorService,
    private confirmationService: ConfirmationService,
    private call4UService: Call4UService,
    private call4uAudioService: Call4uAudioService,
    private ACService: ActiveCampaignService,
    private whatsappAccountsService: WhatsappAccountsService,
    private metaWhatsapp: MetaWhatsappService,
    private rcsAgentService: RcsAgentService,
    private rcsSettingsService: RcsSettingsService,
  ) {
    this.user = this.auth.getUser();
    this.usedCall4U = this.user.call4u_user_id !== null;
   }


  ngOnInit(): void {
    this.CALL4U_DOCS = environment.CALL4U_DOCS_2;
    this.sequenceForm = this.formBuilder.group({
      id: [''],
      active: [true],
      campaign_id: [this.campaign.id],
      interval: [0, Validators.required],
      text: ['', Validators.maxLength(this.messageMaxLength)],
      url: ['', urlValidatorService()],
      short_url: [''],
      interval_type_id: [1, Validators.required],
      sequence_type: ['sms', Validators.required],

      coupon: ['', Validators.maxLength(250)],
      cross_checkout_url: ['', platformPatternValidator()],

      call4u_campaign_url: ['', urlValidatorService()],
      call4u_campaign_description: [''],
      call4u_audio_id: [null],
      call_max_attempts: [3],
      call_retry_interval_minutes: [60],

    });

    this.tagForm = this.formBuilder.group({
      name: [Validators.required],
      description: ['']
    });

    this.subscriptions.push(
      this.sequencesService.listIntervalTypes().subscribe(intervalTypes => this.intervalTypes = intervalTypes)
    );
    this.call4UService.isActivated().subscribe((response: IntegrationActivationStatus) => {
      this.usedCall4U = response.status;
    });

    this.loadCall4uAudios();
    this.loadWhatsappContext();
    this.loadRcsAgents();

    // O "Meu link" do SMS só existe com a tag: tirou a tag, o link (e o erro de URL dele, que
    // ficaria escondido travando o Salvar) sai junto — é o que o salvar grava de qualquer jeito.
    // Só no SMS: o "Meu link" do Active Campaign não depende de texto e continua validado (review de
    // 09/10 12:15 — o `reset()` do modal zerava o texto e derrubava a validação do AC). Por isso
    // também ouve a troca de tipo, que chega depois do texto no `reset` + `patchValue`.
    this.subscriptions.push(
      // Sem a tag o campo some: a validação dele também, para um erro escondido não travar o
      // Salvar. O valor fica (recortar e colar a tag não apaga a URL); o save grava null sem a tag.
      merge(this.sequenceForm.get('text').valueChanges, this.sequenceForm.get('sequence_type').valueChanges)
        .subscribe(() => this.syncUrlValidator())
    );

    this.have_list_integration = this.campaign.lead_list && this.campaign.lead_list.integration
                                    && this.campaign.lead_list.integration
                                    && this.campaign.lead_list.integration.platform
                                    && this.list_integration.includes(this.campaign.lead_list.integration.platform.id);

    this.user = this.auth.getUser();
    if (this.user.call4u_user_id) {
      this.usedCall4U = true;
    }

    // Carregar tags se leadList já estiver disponível
    if (this.leadList) {
      try {
        this.loadTags();
      } catch {
        // Ignore
      }
    }
  }

  /** Números e catálogo de variáveis, só para quem tem WhatsApp — o endpoint barra os outros. */
  private loadWhatsappContext(): void {
    if (!this.whatsappAvailable) {
      return;
    }

    this.loadAccounts();
    this.subscriptions.push(
      this.metaWhatsapp.leadVariables().subscribe({
        next: list => {
          this.leadVariables = list || [];
          this.rebuildItemBodies();
        },
        error: () => { /* o chip mostra o token cru */ },
      })
    );
  }

  loadAccounts(): void {
    this.loadingAccounts = true;
    this.accountsError = false;
    this.subscriptions.push(
      this.whatsappAccountsService.list().subscribe({
        next: res => {
          this.whatsappAccounts = res?.data || [];
          this.loadingAccounts = false;
          this.loadItemTemplates();
        },
        error: () => {
          this.loadingAccounts = false;
          this.accountsError = true;
        },
      })
    );
  }

  /** Corpo do template de cada item de WhatsApp: uma listagem por número usado na sequência. */
  private loadItemTemplates(): void {
    const ids = new Set((this.sequences || [])
      .filter(s => s.sequence_type === 'whatsapp')
      .map(s => s.meta_whatsapp_account_id || s.whatsapp_account?.id)
      .filter(id => !!id && !this.templatesByAccount[id]));

    ids.forEach(id => {
      this.templatesByAccount[id] = [];
      this.subscriptions.push(
        this.whatsappAccountsService.listTemplates(id).subscribe({
          next: list => {
            this.templatesByAccount[id] = list || [];
            this.rebuildItemBodies();
          },
          error: () => { /* item mostra só o nome do template */ },
        })
      );
    });
    this.rebuildItemBodies();
  }

  private rebuildItemBodies(): void {
    const bodies: { [sequenceId: string]: string } = {};
    const variables: { [sequenceId: string]: ItemTemplateVariables } = {};
    (this.sequences || [])
      .filter(s => s.sequence_type === 'whatsapp' && s.template_name)
      .forEach(s => {
        bodies[s.id] = this.templateBodyOf(s);
        variables[s.id] = this.templateVariablesOf(s);
      });
    this.itemBodies = bodies;
    this.itemVariables = variables;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.leadList) {
      this.leadList = changes.leadList.currentValue;
      try {
        this.loadTags();
      } catch {
        // Ignore
      }
    }

    if (changes.campaign) {
      this.campaign = changes.campaign.currentValue;
    }

    if (changes.sequences && this.whatsappAccounts.length) {
      this.loadItemTemplates();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getMessageType(sequence: Sequence): string {
    const messages = {
      active_campaign: 'Active Campaign',
      call4u: 'Mensagem de Voz',
      sms: 'Mensagem SMS',
      rcs: 'Mensagem RCS',
      voxuy: 'WhatsApp Voxuy',
      whatsapp: this.isLegacyWhatsapp(sequence) ? 'Meu WhatsApp (antigo)' : 'WhatsApp',
      controls_ai: 'Conversa com IA',
      webhook: 'Webhook',
    };

    return messages[sequence.sequence_type] ?? messages.sms;
  }

  typeClass(sequence: Sequence): string {
    if (this.isLegacyWhatsapp(sequence)) {
      return 'legacy';
    }
    const classes = { whatsapp: 'wa', voxuy: 'legacy', controls_ai: 'ai', rcs: 'rcs', call4u: 'call', webhook: 'hook' };
    return classes[sequence.sequence_type] || '';
  }

  private itemTemplate(sequence: Sequence) {
    const accountId = sequence.meta_whatsapp_account_id || sequence.whatsapp_account?.id;
    return findTemplate(this.templatesByAccount[accountId] || [], sequence.template_name, sequence.template_language);
  }

  private templateBodyOf(sequence: Sequence): string {
    const tpl = this.itemTemplate(sequence);
    const { map } = normalizeTemplateMapping(sequence.template_variables, templateSlots(tpl));
    return fillTemplateText(templateBodyText(tpl), 'body', map, token => `{{${this.variableLabel(token)}}}`);
  }

  /**
   * O que preenche cada variável do template e, no passo salvo antes do mapeamento nomeado, o
   * aviso: a variável de nome vai com o primeiro nome do lead; a que não tem dado cancela o envio.
   */
  private templateVariablesOf(sequence: Sequence): ItemTemplateVariables {
    const tpl = this.itemTemplate(sequence);
    const stored = sequence.template_variables;

    if (!tpl) {
      // Sem a lista do número: o que estava salvo, como estava.
      const entries = Array.isArray(stored)
        ? stored.map((token, i) => `{{${i + 1}}} ${token ? this.variableLabel(token) : '—'}`)
        : Object.keys(stored || {}).map(key => `{{${key.split(':')[1]}}} ${this.variableLabel(stored[key])}`);
      return { summary: entries.join(' · '), defaulted: [], missing: [] };
    }

    const slots = templateSlots(tpl);
    const { map, defaulted } = normalizeTemplateMapping(stored, slots);
    const legacy = isLegacyMapping(stored);
    return {
      summary: slots.map(slot => `${slot.label} ${map[slot.key] ? this.variableLabel(map[slot.key]) : '—'}`).join(' · '),
      defaulted: legacy ? slots.filter(slot => defaulted.includes(slot.key)).map(slot => slot.label) : [],
      missing: slots.filter(slot => !mappingSource(map[slot.key]).value.trim()).map(slot => slot.label),
    };
  }

  private variableLabel(token: string): string {
    if (token === MY_LINK_TOKEN) {
      return MY_LINK_LABEL.toLowerCase();
    }
    const source = mappingSource(token);
    if (source.fixed) {
      return `“${source.value}”`;
    }
    return (this.leadVariables.find(v => v.token === token)?.label || token).toLowerCase();
  }

  hasFollowup(sequence: Sequence): boolean {
    return !!sequence.text && Number(sequence.followup_window) > 0;
  }

  followupSummary(sequence: Sequence): string {
    const unit = Number(sequence.followup_window_type_id) === HOUR_INTERVAL ? 'h' : ' min';
    const link = (sequence.text || '').includes('{meu_link}') ? ' com {meu_link}' : '';
    return `Se responder em ${sequence.followup_window}${unit}: texto livre${link}`;
  }

  accountBroken(sequence: Sequence): boolean {
    const accountId = sequence.meta_whatsapp_account_id || sequence.whatsapp_account?.id;
    const account = this.whatsappAccounts.find(a => a.id === accountId) || sequence.whatsapp_account;
    return isAccountBroken(account as any);
  }

  /** Modal em passos do WhatsApp (M4). Editar abre no resumo. */
  openWhatsapp(sequence: Sequence = null): void {
    if (!this.campaign.lead_list_id) {
      return this.toastService.error('Por favor, cadastre uma lista à campanha para utilizar isto.');
    }

    const ref = this.modalService.open(WhatsappSequenceModalComponent, { size: 'xl', scrollable: true });
    ref.componentInstance.campaign = this.campaign;
    ref.componentInstance.leadList = this.leadList;
    ref.componentInstance.intervalTypes = this.intervalTypes;
    ref.componentInstance.sequence = sequence;
    ref.result.then(
      (saved: any) => {
        // Template criado/aprovado na aba nova: a linha do tempo busca os do número de novo.
        const accountId = saved?.meta_whatsapp_account_id || sequence?.meta_whatsapp_account_id;
        if (accountId) {
          delete this.templatesByAccount[accountId];
        }
        this.listAll();
      },
      () => { /* fechou sem salvar */ }
    );
  }

  loadTags(): void {
    this.tags = this.sequencesService.getTags(this.leadList);
    this.rcsVariables = (this.tags || [])
      .map(tag => ({ tag: tag.tag.trim().replace(/^\{|\}$/g, ''), label: tag.title }))
      .filter(variable => variable.tag !== 'contentmsg' && variable.tag !== 'meu_link');
    // O código copiável é o pix_code do lead, tanto em listas manuais como automáticas.
    this.rcsVariables.push({ tag: 'pix_code', label: 'Código Pix do lead' });
  }

  detectPlatformCrossCheckout(): void {
    const platform = detectPlatformByPattern(this.sequenceForm.get('cross_checkout_url').value);

    if (platform) {
      this.checkout_cross_platform = platform;
      return;
    }

    this.checkout_cross_platform = false;
  }

  toggleActive(sequence: Sequence): void {
    if (sequence.is_ac && !this.campaign.active_campaign) {
      this.toastService.error('Não é possível ativar essa sequência pois não há dados Active Campaign cadastrados.');
      this.listAll();
      return;
    }

    sequence.active = !sequence.active;

    const successMessage = sequence.active
      ? 'Sequência ativada com sucesso!'
      : 'Sequência desativada com sucesso!';

    // Falhou: o switch volta, senão mostraria desligado um passo que continua enviando.
    this.subscriptions.push(
      this.sequencesService.updateStatus(sequence).subscribe({
        next: () => this.toastService.success(successMessage),
        error: res => {
          sequence.active = !sequence.active;
          this.toastService.error(res?.error?.message || 'Não foi possível alterar o passo. Tente de novo.');
        },
      })
    );
  }

  listAll(): void {
    this.loadingSequences = true;
    this.subscriptions.push(
      this.sequencesService.listByCampaignId(this.campaign.id).subscribe({
        next: sequences => {
          this.loadingSequences = false;
          this.sequences = sequences;
          this.loadItemTemplates();
        },
        error: () => { this.loadingSequences = false; },
      })
    );
  }

  /**
   * Gravação da sequência, seja qual for o tipo (CU-86akkubzz).
   *
   * Os cinco caminhos de salvar — SMS/WhatsApp, Call4U, webhook, Voxuy e Active
   * Campaign — repetiam este mesmo bloco, e a trava do botão teria de ser
   * repetida cinco vezes junto. A flag liga aqui, DEPOIS das validações de cada
   * caminho: ligá-la no `save()` deixaria o botão travado para sempre a cada
   * campo que o toast recusa.
   */
  private persistSequence(sequence: any, modal: any, successMessage: string, errorMessage: string): void {
    this.saving = true;
    this.subscriptions.push(
      this.sequencesService.save(sequence).subscribe(
        () => {
          this.saving = false;
          this.toastService.success(successMessage);
          this.listAll();
          modal.close();
        },
        res => {
          this.saving = false;
          this.toastService.error(res?.error?.message || errorMessage);
        })
    );
  }

  checkMsgType(sequence: Sequence = null, returnText: boolean = false): number|string {

    if (!sequence) {
      sequence = this.sequenceForm.getRawValue() as Sequence;
    }

    if (sequence.sequence_type === 'webhook') {
      return returnText ? 'Webhook' : 4;
    }

    if (sequence.sequence_type === RCS_SEQUENCE_TYPE) {
      return returnText ? 'Mensagem RCS' : 5;
    }

    if (sequence.sequence_type === 'call4u' || sequence.call4u_audio_id) {
      return returnText ? 'Mensagem de Voz' : 0; // Call4U
    }

    if (sequence.text) {
      return returnText ? 'Mensagem de SMS' : 1; // SMS
    }

    if (sequence.is_ac) {
      return returnText ? 'Active Campaign' : 2; // Active Campaign
    }

    if (sequence.voxuy_campaign_url) {
      return returnText ? 'Mensagem de WhatsApp' : 3; // Voxuy
    }

    return returnText ? 'Mensagem de SMS' : 1;
  }

  getMsgTypeIcon(sequence: Sequence): string {
    if (sequence.sequence_type === 'controls_ai') {
      return 'fa-comments';
    }
    if (sequence.sequence_type === 'whatsapp' || sequence.sequence_type === 'voxuy') {
      return 'fa-whatsapp';
    }

    const msgType = this.checkMsgType(sequence);

    switch (msgType) {
      case 0:
        return 'fa-phone';
      case 1:
        return 'fa-comment';
      case 3:
        return 'fa-comment';
      case 2:
        return 'fa-tag';
      case 4:
        return 'fa-link';
      case 5:
        return 'fa-commenting';
    }

    return 'fa-comment';
  }

  addTag(tag: string): void {
    if (tag === '{contentmsg}') {
      this.confirmationService
      .show('Esta tag irá substituir todo o texto da mensagem, deseja adicioná-la mesmo assim?',
        () => {
          this.sequenceForm.patchValue({ text: tag });
        });
      return;
    }

    let text = this.sequenceForm.get('text').value || '';

    if (text.includes('{contentmsg}')) {
      text = text.replace('{contentmsg}', '');
      this.toastService.info('Tag {contentmsg} removida automaticamente.');
    }

    const size = text.length + `${tag}`.length;
    if (size < 150) {
      const beforeText = text.substring(0, this.startPosition);
      const afterText = text.substring(this.endPosition, text.length);

      text = beforeText + tag + afterText;

      this.sequenceForm.patchValue({ text });
    } else {
      this.toastService.error('Não há espaço suficiente para inserir esta TAG');
    }
  }

  /**
   * Cada botão da barra abre o modal do seu tipo (M4): o dropdown de tipo e o modal
   * intermediário saíram, e o WhatsApp tem modal próprio (`openWhatsapp`).
   */
  newOfType(sequenceType: string, modal: any): void {
    this.modalTitle = this.titleFor(sequenceType);
    this.sequenceForm.reset();
    this.sendLeadNumber = false;
    this.sequenceForm.patchValue({
      campaign_id: this.campaign.id,
      active: true,
      sequence_type: sequenceType,
      interval: 1,
      interval_type_id: 1,
      call_max_attempts: 3,
      call_retry_interval_minutes: 60,
    });
    this.rcsAgentId = null;
    this.rcsContent = emptyContent();
    this.rcsState = null;
    this.setReadCondition(null);
    this.modalService.open(modal, { size: this.modalSizeFor(sequenceType) });
    this.syncActiveCampaignTags(sequenceType === 'active_campaign');
  }

  private syncUrlValidator(): void {
    const url = this.sequenceForm.get('url');
    const smsWithoutLink = this.sequenceType === 'sms' && !(this.sequenceForm.get('text').value || '').includes('{meu_link}');
    url.setValidators(smsWithoutLink ? [] : [urlValidatorService()]);
    url.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * As tags do Active Campaign só interessam ao passo de AC (review de 09/10/2026): abrir SMS, voz
   * ou webhook chamava a API do AC e mostrava "Sincronizando..." à toa. Os outros tipos só zeram as
   * colunas, que é o que a busca devolvia para eles (o `save` do SMS confere que não há tag).
   */
  private syncActiveCampaignTags(isActiveCampaign: boolean): void {
    if (isActiveCampaign) {
      this.refreshACInfo();
      return;
    }
    this.AC_tags = [];
    this.AC_selected_tags = [];
  }

  private titleFor(sequenceType: string): string {
    const titles = {
      sms: 'Mensagem SMS',
      rcs: 'Mensagem RCS',
      call4u: 'Mensagem de voz',
      webhook: 'Webhook',
      active_campaign: 'Active Campaign',
    };
    return titles[sequenceType] || 'Nova ação';
  }

  edit(sequence: Sequence, modal: any): void {

    if (!this.campaign.lead_list_id) {
      return this.toastService.error('Por favor, cadastre uma lista à campanha para utilizar isto.');
    }

    // Voxuy, Conversa com IA e o "Meu WhatsApp" antigo são somente leitura (ver isReadOnly).
    if (this.isReadOnly(sequence)) {
      return;
    }

    if (sequence.sequence_type === 'whatsapp') {
      return this.openWhatsapp(sequence);
    }

    this.sequenceForm.reset();
    this.sequenceForm.patchValue(sequence);
    this.sendLeadNumber = sequence.send_lead_number;
    this.rcsAgentId = sequence.rcs_agent_id || null;
    this.rcsContent = sequence.rcs_content || emptyContent();
    this.rcsState = null;
    this.setReadCondition(sequence.rcs_read_condition);
    this.modalTitle = this.titleFor(sequence.sequence_type);
    this.modalService.open(modal, { size: this.modalSizeFor(sequence.sequence_type) });
    this.syncActiveCampaignTags(sequence.sequence_type === 'active_campaign' || !!sequence.is_ac);

    // Voz, webhook e AC não têm textarea: o foco vai só para o da mensagem, quando houver.
    setTimeout(() => document.querySelector<HTMLTextAreaElement>('ngb-modal-window textarea')?.focus(), 100);

  }

  remove(sequence: Sequence): void {
    this.confirmationService
      .show('Deseja realmente excluir esta sequência?',
        () => {
          this.sequencesService
            .delete(sequence.id)
            .subscribe(
              () => {
                this.sequences = this.sequences.filter(s => s !== sequence);
                this.toastService.success('Sequência excluída com sucesso!');
              }
            );
        });
  }

  saveTags(modal: any): void {
    const sequence = this.sequenceForm.getRawValue();

    sequence.is_ac = true;
    sequence.ac_tags = this.AC_selected_tags;

    const successMessage = sequence.id
    ? 'Sequência atualizada com sucesso!'
    : 'Sequência inserida com sucesso!';

    const errorMessage = sequence.id
      ? 'Erro ao atualizar sequência.'
      : 'Erro ao inserir sequência.';

    this.persistSequence(sequence, modal, successMessage, errorMessage);
  }

  saveCall4U(modal: any): void {
    const sequence = this.sequenceForm.getRawValue();

    sequence.url = null;
    sequence.text = null;
    sequence.short_url = null;
    sequence.voxuy_campaign_url = null;
    sequence.voxuy_campaign_description = null;

    sequence.is_ac = false;
    sequence.ac_tags = [];

    if (!sequence.call4u_audio_id) {
      return this.toastService.error('Selecione um áudio para a mensagem de voz.');
    }

    if (sequence.call_max_attempts < 1 || sequence.call_max_attempts > 10) {
      return this.toastService.error('O número de tentativas deve ser entre 1 e 10.');
    }

    if (sequence.call_retry_interval_minutes < 1) {
      return this.toastService.error('O intervalo entre tentativas deve ser de no mínimo 1 minuto.');
    }

    const successMessage = sequence.id
    ? 'Sequência atualizada com sucesso!'
    : 'Sequência inserida com sucesso!';

    const errorMessage = sequence.id
      ? 'Erro ao atualizar sequência.'
      : 'Erro ao inserir sequência.';


    this.persistSequence(sequence, modal, successMessage, errorMessage);
  }

  saveWebhook(modal: any): void {
    const sequence = this.sequenceForm.getRawValue();

    sequence.url = null;
    sequence.text = null;
    sequence.short_url = null;
    sequence.voxuy_campaign_url = null;
    sequence.voxuy_campaign_description = null;
    sequence.call4u_audio_id = null;

    sequence.is_ac = false;
    sequence.ac_tags = [];

    if (!sequence.call4u_campaign_url || sequence.call4u_campaign_url === '') {
      return this.toastService.error('O link do webhook é obrigatório.');
    }

    const successMessage = sequence.id
      ? 'Sequência atualizada com sucesso!'
      : 'Sequência inserida com sucesso!';

    const errorMessage = sequence.id
      ? 'Erro ao atualizar sequência.'
      : 'Erro ao inserir sequência.';

    this.persistSequence(sequence, modal, successMessage, errorMessage);
  }

  /**
   * Etapa RCS: o mesmo payload da etapa de WhatsApp (intervalo, tipo de intervalo,
   * campanha, ativo), com o card em `rcs_content` e o remetente em `rcs_agent_id`.
   * O texto do SMS de fallback não vai: o backend gera no vencimento da etapa.
   */
  saveRcs(modal: any): void {
    const sequence = this.sequenceForm.getRawValue();

    if (!this.rcsAgentId) {
      return this.toastService.error('Escolha o agente RCS da etapa.');
    }

    const content = normalizeContent(this.rcsContent);
    const contentProblems = (this.rcsState?.problems || [])
      .filter(problem => !/agente/i.test(problem));
    if (!content.text.trim()) {
      return this.toastService.error('Escreva o texto da mensagem RCS.');
    }
    if (contentProblems.length) {
      return this.toastService.error(contentProblems[0]);
    }

    const readProblems = this.readConditionProblems;
    if (readProblems.length) {
      return this.toastService.error(readProblems[0]);
    }

    sequence.sequence_type = RCS_SEQUENCE_TYPE;
    sequence.text = null;
    sequence.url = null;
    sequence.short_url = null;
    sequence.call4u_campaign_url = null;
    sequence.call4u_campaign_description = null;
    sequence.call4u_audio_id = null;
    sequence.voxuy_campaign_url = null;
    sequence.voxuy_campaign_description = null;
    sequence.is_ac = false;
    sequence.ac_tags = [];
    sequence.send_lead_number = this.sendLeadNumber;
    sequence.rcs_agent_id = this.rcsAgentId;
    sequence.rcs_content = content;

    if (this.readConditionSettings.enabled) {
      sequence.rcs_read_condition = this.readConditionOn
        ? { hours: Number(this.readConditionHours), sms_text: this.readConditionText.trim() }
        : null;
    } else {
      delete sequence.rcs_read_condition;
    }

    const successMessage = sequence.id
      ? 'Sequência atualizada com sucesso!'
      : 'Sequência inserida com sucesso!';

    const errorMessage = sequence.id
      ? 'Erro ao atualizar sequência.'
      : 'Erro ao inserir sequência.';

    this.persistSequence(sequence, modal, successMessage, errorMessage);
  }

  /** Agentes para marcar etapa RCS pausada na lista. Só com o canal ligado na conta. */
  loadRcsAgents(): void {
    if (!this.rcsEnabled) {
      return;
    }

    this.subscriptions.push(
      this.rcsAgentService.list().subscribe({
        next: agents => this.rcsAgents = agents || [],
        error: () => this.rcsAgents = [],
      }),
      this.rcsSettingsService.readCondition().subscribe(settings => this.readConditionSettings = settings),
    );
  }

  save(modal: any): void {
    const sequence = this.sequenceForm.getRawValue() as Sequence;
    sequence.send_lead_number = this.sendLeadNumber;

    if (sequence.sequence_type === RCS_SEQUENCE_TYPE) {
      return this.saveRcs(modal);
    }

    if (sequence.sequence_type === 'call4u') {
      return this.saveCall4U(modal);
    }

    if (sequence.sequence_type === 'webhook') {
      return this.saveWebhook(modal);
    }

    if (sequence.sequence_type === 'active_campaign') {
      return this.saveTags(modal);
    }

    // Sem a tag, o "Meu link" nem aparece na tela: um valor antigo não pode seguir gravado.
    if (sequence.sequence_type === 'sms' && !sequence.text?.includes('{meu_link}')) {
      sequence.url = null;
      sequence.send_lead_number = false;
    }

    sequence.is_ac = false;
    sequence.ac_tags = [];

    const verifyFields = [
      sequence.text ?? null,
      sequence.call4u_campaign_url ?? null,
      this.AC_selected_tags ?? null,
    ].filter((i: any) => {
        if (i == null) {
          return false;
        }

        return i.toString() !== '';
      }
    );

    if (verifyFields.length > 1) {
      return this.toastService.error('Por favor, preencha apenas um tipo de mensagem por sequência.');
    }

    if (sequence.text?.includes('{meu_link}') && !sequence.url?.trim()
    ) {
      this.toastService.error('Meu link é obrigatório quando você utiliza a TAG {meu_link}');
      return;
    }

    const error = this.blacklistValidator.validate(sequence.text);
    if (error) {
      this.toastService.error(error.message);
      return;
    }

    const invalidTags = this.sequencesService.validateTags(sequence, this.tags);
    if (invalidTags.length > 0) {
      this.toastService.error(`Você adicionou uma tag esta plataforma não fornece. ${invalidTags.join(',')}`);
      return;
    }

    const successMessage = sequence.id
      ? 'Sequência atualizada com sucesso!'
      : 'Sequência inserida com sucesso!';

    const errorMessage = sequence.id
      ? 'Erro ao atualizar sequência.'
      : 'Erro ao inserir sequência.';

    this.persistSequence(sequence, modal, successMessage, errorMessage);
  }

  setPosition(e: any): void {
    this.startPosition = e.target.selectionStart;
    this.endPosition = e.target.selectionEnd;
  }

  close(activated: boolean): void {
    if (activated) {
      this.modalService.dismissAll();
      const call4uHeader = document.body.querySelector('#call4u-header');
      if (call4uHeader) {
        call4uHeader.remove();
      }
    }
  }

  onCall4uActivated(activated: boolean): void {
    if (activated) {
      this.usedCall4U = true;
      this.loadCall4uAudios();
    }
  }

  newTag(tagModal: any): void {
    this.tagMode = 1;
    this.tagInEdit = null;
    this.tagForm.reset();
    this.tagForm.patchValue({ name: '' });

    this.modalService.open(tagModal, { size: 'lg' });
  }

  saveTag(modal: any): void {
    const name = this.tagForm.controls.name.getRawValue();
    const description = this.tagForm.controls.description.getRawValue();
    const sequence = this.sequenceForm.getRawValue() as Sequence;

    modal.close();

    if (this.tagMode === 1) {
      this.ACService.createTags(sequence.id, name, this.campaign.id, description).subscribe((response: AC_TAG) => {
        this.AC_tags.push(response);
      });
      this.toastService.success(`Tag "${name}" criada com sucesso!`);
      return;
    }

    const newTag = this.tagInEdit;
    newTag.description = description;
    newTag.tag = name;

    this.ACService.editTags(sequence.id, newTag.id, newTag.tag, this.campaign.id, newTag.description).subscribe((response: any) => {
      if (response.statusCode === 200) {
        const i = this.AC_tags.indexOf(this.tagInEdit);
        this.AC_tags.splice(i, 1);
        this.AC_tags.splice(i, 0, newTag);

        this.toastService.success('Tag editada com sucesso!');
      }
    });
  }

  editTag(tagModal: any, tag: AC_TAG): void {
    this.tagMode = 0;
    this.tagInEdit = tag;
    this.tagForm.reset();
    this.tagForm.patchValue({ name: tag.tag ?? '' , description: tag.description ?? ''});
    this.modalService.open(tagModal, { size: 'lg' });
  }

  deleteTag(tag: AC_TAG): void {
    const sequence = this.sequenceForm.getRawValue() as Sequence;

    this.confirmationService.show(
      `Deseja realmente remover a tag "${tag.tag}"? <br>Esta ação pode ser irreversível.`, () => {
        this.ACService.deleteTags(sequence.id, tag.id, this.campaign.id).subscribe((response: any) => {
          if (response.statusCode === 200) {
            this.toastService.success(`Tag "${tag.tag}" deletada com sucesso!`);
            this.preSelectACTagAll(tag, false);
            this.preSelectACTagSelected(tag, false);
            return this.AC_tags.splice(this.AC_tags.indexOf(tag), 1);
          }
          return this.toastService.error('Ocorreu um problema ao remover esta tag... Por favor, tente novamente mais tarde.');
        });
      });
  }

  preSelectACTagAll(tag: AC_TAG, add: boolean = true): void {
    const index = this.AC_preselected_all.findIndex(item => item.id === tag.id);
    if (index !== -1) {
      this.AC_preselected_all.splice(index, 1);
    } else if (index === -1 && add) {
      this.AC_preselected_all.push(tag);
    }
  }

  preSelectACTagSelected(tag: AC_TAG, add: boolean = true): void {
    const index = this.AC_preselected_selected.findIndex(item => item.id === tag.id);
    if (index !== -1) {
      this.AC_preselected_selected.splice(index, 1);
    } else if (index === -1 && add) {
      this.AC_preselected_selected.push(tag);
    }
  }

  tagIsInPreselected(tag: AC_TAG): boolean {
    const indexAll = this.AC_preselected_all.findIndex(item => item.id === tag.id);
    const indexSelected = this.AC_preselected_selected.findIndex(item => item.id === tag.id);
    return indexAll !== -1 || indexSelected !== -1;
  }

  toAll(): void {
    this.AC_preselected_selected.forEach(tag => {
      const index = this.AC_selected_tags.indexOf(tag);
      if (!this.AC_tags.includes(tag)) {
        this.AC_selected_tags.splice(index, 1);
        this.AC_tags.push(tag);
      }
    });

    this.AC_preselected_selected = [];
  }

  toSelect(): void {
    this.AC_preselected_all.forEach(tag => {
      const index = this.AC_tags.indexOf(tag);
      if (!this.AC_selected_tags.includes(tag)) {
        this.AC_tags.splice(index, 1);
        this.AC_selected_tags.push(tag);
      }
    });

    this.AC_preselected_all = [];
  }

  refreshACInfo(notify: boolean = true): void {
    this.AC_tags = [];
    this.AC_selected_tags = [];

    const sequence = this.sequenceForm.getRawValue() as Sequence;
    this.refreshAC = true;

    if (!this.campaign.lead_list || !this.campaign.ac_infos) {
      return;
    }

    this.AC_Activated = this.campaign.ac_infos != null;

    if (!this.AC_Activated) {
      return;
    }

    if (notify) {
      this.toastService.info('Sincronizando informações do Active Campaign...');
    }

    this.sequencesService.getAcTags(sequence.id, this.campaign.id).subscribe((response: AC_TAG[][]) => {
      if (!response) {
        this.refreshACInfo(false);
        return;
      }
      this.AC_tags = response[0];
      this.AC_selected_tags = response[1];
    });

    setTimeout(() => this.refreshAC = false, 5000);
  }

  messageContentChanged(e): void {
    let text = e.target.value || '';

    if (e.target.value.includes('{contentmsg}')) {
      text = text.replace('{contentmsg}', '');
      this.toastService.info('Tag {contentmsg} removida automaticamente.');
    }

    e.target.value = text;
  }

  loadCall4uAudios(): void {
    this.subscriptions.push(
      this.call4uAudioService.list(1, 100).subscribe(response => {
        this.call4uAudios = response.data.filter(a => a.status === 'approved');
      })
    );
  }

  getSelectedAudio(): Call4uAudio | null {
    const audioId = this.sequenceForm.get('call4u_audio_id')?.value;
    if (!audioId) return null;
    return this.call4uAudios.find(a => a.id === audioId) || null;
  }

  formatDuration(seconds: number): string {
    if (!seconds) return '--';
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return min > 0 ? `${min}m ${sec}s` : `${sec}s`;
  }

  copyPwd(): void {
    navigator.clipboard.writeText('newCallUser').then(() => {
      this.toastService.success('Senha copiada com sucesso!');
    });
  }
}
